import React from 'react';
import { WizardState } from '../../../hooks/useZakatWizard';
import { Input } from '../../ui/Input';
import { Card } from '../../ui/Card';
import { Info } from 'lucide-react';
interface InvestmentsStepProps {
  state: WizardState;
  updateState: (updates: Partial<WizardState>) => void;
}
const displayVal = (v: number) => v === 0 ? '' : v;
export function InvestmentsStep({
  state,
  updateState
}: InvestmentsStepProps) {
  return <div className="space-y-6" data-id="element-424">
      <div className="mb-6" data-id="element-425">
        <h2 className="text-2xl font-bold text-gray-900 font-serif mb-2" data-id="element-426">
          My Investments
        </h2>
        <p className="text-gray-600" data-id="element-427">
          Enter the current market value of your investment accounts. For
          stocks, use today's value. For crypto, use the value at the time
          you're calculating.
        </p>
      </div>

      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 flex gap-3 text-sm text-blue-800 mb-6" data-id="element-428">
        <Info className="h-5 w-5 flex-shrink-0 mt-0.5" data-id="element-429" />
        <p data-id="element-430">
          Zakat is generally due on the full market value of liquid investments
          like stocks and crypto that are held for capital appreciation or
          trading.
        </p>
      </div>

      <Card className="space-y-6" data-id="element-431">
        <Input label="Stocks & ETFs (Brokerage Accounts)" prefix="$" type="number" placeholder="0.00" value={displayVal(state.stocksEtfs)} onChange={e => updateState({
        stocksEtfs: parseFloat(e.target.value) || 0
      })} data-id="element-432" />

        <Input label="Mutual Funds" prefix="$" type="number" placeholder="0.00" value={displayVal(state.mutualFunds)} onChange={e => updateState({
        mutualFunds: parseFloat(e.target.value) || 0
      })} data-id="element-433" />

        <Input label="Bonds / Sukuk" prefix="$" type="number" placeholder="0.00" value={displayVal(state.bonds)} onChange={e => updateState({
        bonds: parseFloat(e.target.value) || 0
      })} data-id="element-434" />

        <Input label="Cryptocurrency" prefix="$" type="number" placeholder="0.00" value={displayVal(state.crypto)} onChange={e => updateState({
        crypto: parseFloat(e.target.value) || 0
      })} data-id="element-435" />
      </Card>
    </div>;
}